import React, { useState, useContext } from 'react';
import '../assets/cssModules/pages/pages.css';
import Alert from 'react-bootstrap/Alert';
import { createDataset } from '../../services/dataset.service';
import LoadingScreen from '../../components/elements/LoadingScreen';
import PageHeader from '../../components/elements/PageHeader';
import { ActionButton } from '../../components/elements/Button';
import { AuthContext } from "../../services/auth.service";
import configService from '../../services/config.service';

export const CreateDataset = () => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertContent, setAlertContent] = useState({});
    const [product, setProduct] = useState("");
    const [loadingActive, SetLoadingActive] = useState(false);

    const {companyId, companyInfo} = useContext(AuthContext)

    const handleSelectChange = (event) => setProduct(event.target.value);

    const activeProducts = () => {
        const products = [];

        if (companyInfo?.tag_monitor) {
            products.push({ value: "tag-monitor", label: "Tag Monitor" });
        }
        if (companyInfo?.datalayer_guard) {
            products.push({ value: "datalayer-guard", label: "Datalayer Guard" });
        }
        if (companyInfo?.sitespeed_monitor) {
            products.push({ value: "sitespeed-monitor", label: "Sitespeed Monitor" });
        }

        return products;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        SetLoadingActive(true);

        let datasetResponse;
        let saveResponse;
        let saveResponseData;
        let isDatasetOk = false;
        let isSaveOk = true;

        try {
            datasetResponse = await createDataset({
                "companyId": companyId,
                "product": product,
            });
            isDatasetOk = datasetResponse?.success && datasetResponse?.result
            
            if ((product === "tag-monitor" || product === "tag-monitor-premium") && isDatasetOk){
                const resp = await configService.getTagMonitorConfigData(companyId)
                const respData = await resp.json();

                const currentConfig = respData?.config_data?.current_config;

                if (currentConfig) {
                    currentConfig["database_name"] = datasetResponse?.dataset_name;
                    saveResponse = await configService.saveTagMonitorConfigData({configObj: currentConfig, companyId: companyId});
                    saveResponseData = await saveResponse.json();
                    isSaveOk = saveResponseData?.result === true;
                } else {
                    isSaveOk = false;
                    saveResponseData = { error: "Configuration data is missing" };
                }
        }} catch (error) {
            setShowAlert(true);
            setAlertContent({
                heading: "Something went wrong while creating the dataset. Please check whether the dataset already exists before trying again.",
                variant: "danger"
            });
            return;
        } finally {
            SetLoadingActive(false);
        }

        if (isDatasetOk && isSaveOk) {
            setShowAlert(true);
            let alertContent;

            if (datasetResponse?.dataset_already_exists === false) {
                alertContent = {
                    heading: `Dataset created and linked to ${datasetResponse?.company_name}.`,
                    variant: "success"
                };
            } else {
                alertContent = {
                    heading: `A dataset already exists for ${datasetResponse?.company_name}. No new resources were created.`,
                    variant: "warning"
                };
            }

            setAlertContent(alertContent);
        } else if (!isDatasetOk) {
            setShowAlert(true);
            setAlertContent({
                heading: `Could not create the dataset for ${datasetResponse?.company_name}: ${datasetResponse?.error || "unknown error"}`,
                variant: "danger"
            });
        } else if (!isSaveOk) {
            setShowAlert(true);
            setAlertContent({
                heading: `The dataset was created, but saving it to the Tag Monitor configuration failed: ${saveResponseData?.error || "unknown error"}. Please link the dataset manually in the Tag Monitor configuration.`,
                variant: "danger"
            });
        }
    };

    return (
        <div>
            <LoadingScreen isActive={loadingActive} />
            <PageHeader categoryName="admin" pageName="Create Datasets" />

            <div className='create-dataset'>
                <div className='col-5 mt-3'>
                    {
                        showAlert &&
                        <Alert variant={alertContent.variant}>
                            {alertContent.heading}
                        </Alert>
                    }
                    <form method="POST" className="row mt-4" onSubmit={handleSubmit}>
                        <div className='mb-4'>
                            <p>Create a dataset for {companyInfo?.name}</p>
                            <label htmlFor='company_id' className='pb-1' style={{ fontSize: '.9em', color: "blue", letterSpacing: .3}}>
                                Please create the company profile before creating the dataset
                            </label>
                            <select
                                className='form-select mt-2'
                                value={product}
                                onChange={handleSelectChange}
                            >
                                <option value="">Select product</option>
                                {activeProducts().map((product) => (
                                    <option key={product.value} value={product.value}>
                                    {product.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="row pe-0">
                            <div className="d-grid col-4 pe-0">
                                <ActionButton
                                    text="Submit"
                                    size="middle"
                                    onClickFunction={handleSubmit}
                                    disabled={loadingActive}
                                />
                            </div>
                        </div>
                        <br />
                    </form>
                </div>
            </div>
        </div>
    );
};